export function createPositiveIntegerValidator({
  errorMessage = 'Value must be positive integer',
}: {
  errorMessage?: string;
}) {
  return {
    validate: (value: string) => {
      const int = parseInt(value.toString(), 10);
      const isNumber = !Number.isNaN(int);
      const hasDecimal = value.toString().includes('.');
      const isPositive = !!(isNumber === true && int > 0);

      if (isNumber && !hasDecimal && isPositive) {
        return true;
      }

      return errorMessage;
    },
  };
}
